export default {"src":"/_next/static/media/money.af2069f3.svg","height":36,"width":36,"blurWidth":0,"blurHeight":0};